import React, { FC } from 'react';
import * as StyledOnboarding from './onboarding.styles';

export interface Step {
	heading: string;
	details: string;
}

interface Props {
	active: number;
	setActive: any;
	steps: Step[];
}

const OnboardingSteps: FC<Props> = ({ active, setActive, steps }) => {
	return (
		<StyledOnboarding.Steps>
			<div>
				{steps.map((step, index) => {
					const highlight = active === index;
					const fulfilled = index < active;

					return (
						<StyledOnboarding.Step
							active={highlight}
							onClick={() => {
								if (index < active) {
									setActive(index);
									window.sessionStorage.setItem('onboardingTab', String(index));
								}
							}}>
							<StyledOnboarding.Bubble active={highlight} fulfilled={fulfilled}>
								{fulfilled ? '✓' : (index + 1).toString()}
							</StyledOnboarding.Bubble>
							<StyledOnboarding.BubbleText>
								<StyledOnboarding.BubbleHeading>{step.heading}</StyledOnboarding.BubbleHeading>
								{step.details}
							</StyledOnboarding.BubbleText>
						</StyledOnboarding.Step>
					);
				})}
			</div>
		</StyledOnboarding.Steps>
	);
};

export default OnboardingSteps;
